module.exports = __webpack_public_path__ + "img/icon14.5a5806fd.png";